import moment from 'moment-timezone';

/**
 * Oct 20, 2019 7:25:02 PM
 */
export const formatDateAndTime = date => {
  return moment(date).format('ll h:mm:ss A');
};

/**
 * Oct 20, 2019
 */
export const formatDate = date => {
  return moment(date).format('ll');
};

/**
 * 8:35 PM
 */
export const formatTime = date => {
  return moment(date).format('LT');
};

/**
 * 8:35:01 PM
 */
export const formatTimeWithSeconds = date => {
  return moment(date).format('LTS');
};

/**
 * Converts a string representation of a Date to a moment object using
 * local timezone
 *
 * @param {string} value string representation of a Date
 * @param {*} ignoreCache default TRUE. Pass FALSE to use cached timezone
 *
 * @returns moment object using local timezone
 */
export const toMoment = (value, ignoreCache = true) =>
  moment.tz(value, moment.tz.guess(ignoreCache));

export const toDate = value => {
  try {
    if (value) {
      value = moment(value);

      if (value && value.isValid()) {
        value = value.toDate();

        if (String(value).toLowerCase() !== 'invalid date') {
          return value;
        }
      }
    }
  } catch (err) {}

  return null;
};
